(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(min-width: 768px)');

  function initAll() {
    var containers = document.querySelectorAll('.colour-options');
    containers.forEach(function (container) {
      if (container.dataset.colourOptionsInit) return;
      container.dataset.colourOptionsInit = 'true';

      var curEl = container.querySelector('.cur-colour');
      if (!curEl) return;
      var originalText = curEl.textContent;

      function setCur(name) { curEl.textContent = name || ''; }

      container.addEventListener('pointerover', function (e) {
        var swatch = e.target.closest && e.target.closest('a[title]');
        if (!swatch || !container.contains(swatch)) return;
        var name = swatch.getAttribute('title') || '';
        name = name.replace(/\s*\(unavailable\)$/i, '');
        setCur(name);
      });

      container.addEventListener('pointerout', function (e) {
        var leftSwatch = e.target.closest && e.target.closest('a[title]');
        if (!leftSwatch || !container.contains(leftSwatch)) return;

        var related = e.relatedTarget;
        var enteredSwatch = related && related.closest && related.closest('a[title]');

        // If pointer moved to another swatch inside the same container, don't revert.
        if (enteredSwatch && container.contains(enteredSwatch)) return;

        // Otherwise revert to original text (moved to non-swatch area or left container)
        setCur(originalText);
      });
    });
  }

  function handleChange(m) {
    if (m.matches) initAll();
  }

  mq.addEventListener ? mq.addEventListener('change', handleChange) : mq.addListener(handleChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (mq.matches) initAll();
    });
  } else {
    if (mq.matches) initAll();
  }
})();
